export { homepageTestimonials } from '~/features/testimonials/data/homepage-testimonials';
